export const MIN_ACTION_LOADING_MS = 500;

export async function ensureMinLoading(startedAt) {
  const elapsed = Date.now() - startedAt;
  const remaining = Math.max(0, MIN_ACTION_LOADING_MS - elapsed);
  if (remaining > 0) {
    await new Promise((resolve) => setTimeout(resolve, remaining));
  }
}
